export default __webpack_public_path__ + "assets/images/d3b5de9c95cc51aa62602defb3f1b47e.png";